import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from "react-native"


import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import BankTransferPaymentScreen from './BankTransferPaymentScreen';


/*

  Esta pantalla recibe unit_fee_ids (array) (y total_amount?) y unitId
  y aquí el usuario debería poder elegir el método de pago (según tenga habilitado el community)
  Ahorita como solo hay transferencia muestra directamente esa pantalla

*/

export default function PaymentMethodScreen(props) {
  // unit_fee_ids
  // unitId
  // return_to_unit_fee_id

  return (
    <BankTransferPaymentScreen {...props} />
  )
}

